import { Plans, Plan, PlanDefinition } from './types';
// TODO import not working, returns undefined - (import { BILLING_CURRENCY } from 'common/modules/billing';)

export const PlanDefinitions: Record<Plan, PlanDefinition> = {
	[Plans.LITE]: {
		id: Plans.LITE,
		name: 'Rentle Free',
		pricing: null,
		blockSlots: 0,
	},
	[Plans.CORE_COMMISSION]: {
		id: Plans.CORE_COMMISSION,
		name: 'Core Commission',
		pricing: {
			fixed: {
				amount: {
					value: 1_90,
					currency: 'USD',
				},
				description: 'Fee per booking',
			},
			commission: null,
		},
		blockSlots: 16,
	},
	[Plans.CORE_FIXED]: {
		id: Plans.CORE_FIXED,
		name: 'Core Fixed',
		pricing: {
			fixed: {
				amount: {
					value: 4900_00,
					currency: 'USD',
				},
				description: 'Price per year, per store',
			},
			commission: null,
		},
		blockSlots: 16,
	},
	[Plans.CORE_DEMO]: {
		id: Plans.CORE_DEMO,
		name: 'Core Demo',
		pricing: null,
		blockSlots: 16,
	},
	[Plans.CORE_INTERNAL_ONLY]: {
		id: Plans.CORE_INTERNAL_ONLY,
		name: 'Core Internal Only',
		pricing: null,
		blockSlots: 16,
	},
	[Plans.ENTERPRISE]: {
		id: Plans.ENTERPRISE,
		name: 'Enterprise',
		pricing: null,
		blockSlots: 16,
	},
	[Plans.BASIC]: {
		id: Plans.BASIC,
		name: 'Rentle Basic',
		blockSlots: 6,
		pricing: {
			fixed: {
				amount: {
					value: 39_00,
					currency: 'USD',
				},
				description: 'Price per month, per store',
			},
			commission: null,
		},
	},
	[Plans.GROW]: {
		id: Plans.GROW,
		name: 'Rentle Grow',
		blockSlots: 8,
		pricing: {
			fixed: {
				amount: {
					value: 79_00,
					currency: 'USD',
				},
				description: 'Price per month, per store',
			},
			commission: null,
		},
	},
	[Plans.ADVANCED]: {
		id: Plans.ADVANCED,
		name: 'Rentle Advanced',
		blockSlots: 16,
		pricing: {
			fixed: {
				amount: {
					value: 399_00,
					currency: 'USD',
				},
				description: 'Price per month, per store',
			},
			commission: null,
		},
	},
};
